import React from 'react';
import Utilisateur from './Utilisateur';
import Collapse from '@mui/material/Collapse';
import FilterListIcon from '@mui/icons-material/FilterList';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import WidgetInputText from '../../../components/widgets/WidgetInputText';
import WidgetSelect from '../../../components/widgets/WidgetSelect';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import CONFIG from '../../../config';

function ListCommerciaux() {
  const navigate = useNavigate();
  const [displayFilters, setDisplayFilters] = React.useState(false);

  const [nom, setNom] = React.useState(null);
  const [prenom, setPrenom] = React.useState(null);
  const [role, setRole] = React.useState(null);
  const [tri, setTri] = React.useState(null);
  const [commerciaux, setCommerciaux] = React.useState(null);

  const applyFilter = (data) => {
    return data.filter((x) => (
      x.nom.toLowerCase().includes(nom?.value.toLowerCase())
      && x.prenom.toLowerCase().includes(prenom?.value.toLowerCase())
      && (role?.value.length === 0
        || ((!role?.value.includes('role_client') || (role?.value.includes('role_client') && x.roles.role_client))
        && (!role?.value.includes('role_commercial') || (role?.value.includes('role_commercial') && x.roles.role_commercial))
        && (!role?.value.includes('role_admin_read') || (role?.value.includes('role_admin_read') && x.roles.role_admin_read))
        && (!role?.value.includes('role_admin_write') || (role?.value.includes('role_admin_write') && x.roles.role_admin_write))
        && (!role?.value.includes('role_comptable') || (role?.value.includes('role_comptable') && x.roles.role_comptable))))
    ))
  }

  const applySort = (data, sortType) => {
    return data.sort((a, b) => {
      switch (sortType) {
        case "nom_up":
          return (a.nom > b.nom) ? 1 : -1;
        case "nom_down":
          return (a.nom < b.nom) ? 1 : -1;
        case "prenom_up":
          return (a.prenom > b.prenom) ? 1 : -1;
        case "prenom_down":
          return (a.prenom < b.prenom) ? 1 : -1;
      }
    })
  }

  React.useEffect(() => {
    axios.get(CONFIG.API_URL + '/api/get_all_users', { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
      .then((response) => {
        switch (response.status) {
          case 200:
            setCommerciaux(response.data);
            break;

          default:
            break;
        }
      })
      .catch((e) => {
        let response = e.response;

        if (response === undefined) {
          alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
          return;
        }

        switch (response.status) {
          default:
            alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
            break;
        }
      });
  }, []);

  return (
    <>
      {commerciaux !== null &&
        <>
          <div className='m-6 grid grid-cols-12 gap-x-4 shrink-0 w-100 bg-white my-shadow'>
            <div className='col-span-12 grid grid-cols-12 p-6 hover:bg-gray-100 cursor-pointer rounded-xl' onClick={() => setDisplayFilters(!displayFilters)}>
              <div className='col-span-6 w-full flex items-center'>
                <div className='inline-block'><FilterListIcon /></div>
                <div className='inline-block'><h3>&nbsp;Filtres & tris</h3></div>
              </div>
              <div className='col-span-6 w-full flex items-center justify-end'>
                <div className='inline-block'>{(!displayFilters) ? <ExpandMoreIcon fontSize="large" /> : <ExpandLessIcon fontSize="large" />}</div>
              </div>
            </div>
            <div className='col-span-12 w-full px-6 shadow-inner shadow-gray-100 bg-gray-50'>
              <Collapse in={displayFilters}>
                <hr className='mb-6'></hr>
                <div className='w-full grid grid-cols-12 gap-4 pb-2'>
                  <div className='col-span-3 w-full mb-4'>
                    <WidgetInputText state={nom} setState={setNom} id={'nom'} text={"Nom"} />
                  </div>

                  <div className='col-span-3 w-full mb-4'>
                    <WidgetInputText state={prenom} setState={setPrenom} id={'prenom'} text={"Prénom"} />
                  </div>

                  <div className='col-span-3 w-full mb-4'>
                    <WidgetSelect state={role} setState={setRole} id={'roles'} text={"Roles"} multiple={true}
                      options={{
                        'role_client': "Client",
                        'role_commercial': "Commercial",
                        'role_admin_read': "Admin read",
                        'role_admin_write': "Admin write",
                        'role_comptable': "Comptable",
                      }}
                    />
                  </div>

                  <div className='col-span-3 w-full mb-4'>
                    <WidgetSelect state={tri} setState={setTri} id={'tri'} text={"Tri"} value={"nom_down"}
                      options={{
                        'nom_up': "Nom ↑",
                        'nom_down': "Nom ↓",
                        'prenom_up': "Prénom ↑",
                        'prenom_down': "Prénom ↓",
                      }}
                    />
                  </div>
                </div>
              </Collapse>
            </div>
          </div>



          <div className='m-6 grid grid-cols-12 gap-x-4 shrink-0 p-6 w-100 bg-white my-shadow'>
            <div className='divide-x col-span-12 grid grid-cols-9 gap-x-2 shrink-0 p-2 mb-2 bg-gray-300 rounded-md my-shadow'>
              <div className='col-span-2 text-ellipsis overflow-hidden whitespace-nowrap pl-2'>
                <b>Nom</b>
              </div>
              <div className='col-span-2 text-ellipsis overflow-hidden whitespace-nowrap pl-2'>
                <b>Prénom</b>
              </div>
              <div className='col-span-1 text-ellipsis overflow-hidden whitespace-nowrap pl-2'>
                <b>Client</b>
              </div>
              <div className='col-span-1 text-ellipsis overflow-hidden whitespace-nowrap pl-2'>
                <b>Commercial</b>
              </div>
              <div className='col-span-1 text-ellipsis overflow-hidden whitespace-nowrap pl-2'>
                <b>Admin lecture</b>
              </div>
              <div className='col-span-1 text-ellipsis overflow-hidden whitespace-nowrap pl-2'>
                <b>Admin écriture</b>
              </div>
              <div className='col-span-1 text-ellipsis overflow-hidden whitespace-nowrap pl-2'>
                <b>Comptabilité</b>
              </div>
            </div>

            {applySort(applyFilter(commerciaux), tri?.value).map((x) => <Utilisateur key={x.nom} data={x}></Utilisateur>)}
          </div>
        </>
      }
    </>
  );
}

export default ListCommerciaux;